import { AnimatePresence, motion, useScroll, useTransform } from 'framer-motion';
import React, { useState } from 'react';

export class Service 
{
    name: string = "";
    price: string = "";
    description: string = "";
}

const services: Array<Service> = [
  {
    name: "Konsultacja neurologopedyczna",
    price: "250 zł",
    description: `Pierwsze spotkanie trwające około 60 minut.
Konsultacja obejmuje:
  - wywiad z rodzicem dotyczący życia dziecka, od okresu prenatalnego do obecnego momentu
  - sprawdzenie rozwoju mowy i komunikacji dziecka
  - badanie manualne w obrębie twarzoczaszki
  - sprawdzenie funkcji prymarnych jamy ustnej 
  - omówienie zauważonych nieprawidłwoości 
  - zaplanowanie przyszłych działań logopedycznych
  - zalecenia po konsultacji`
  },  
  {
    name: "Zajęcia logopedyczne",
    price: "140 zł",
    description: `Zajęcia trwają 45 minut, odbywają się regularnie zgodnie  z ustalonym terminem.
Ich przebieg zależy od potrzeb dziecka wynikających z zaburzeń mowy i języka. Podczas spotkań łączymy pracę manualną, mioterapię, metody pokazowe i słowne oraz holistycznie wspieramy rozwój dziecka.
Podczas zajęć:
  - ćwiczymy prawidłową pozycję języka
  - wzmacniamy mięśnie okalające narządy artykulacyjne 
  - pracujemy nad właściwa wymową
  - wspieramy leczenie ortodontyczne
  - wykonujemy treningi żucia i obróbki pokarmu`
  }, 
  {
    name: "Zajęcia logopedyczne z elektrostymulacją",
    price: "150 zł",
    description: `Zajęcia trwają 45 minut, zabiegi elektrostymulacji są wykonwyane w trakcie zajęć logopedycznych.`
  }, 
  {
    name: "Zabieg elektrostymulacji",
    price: "50 zł",
    description: `Spotkanie trwa do 30 minut.
Zabiegi elektrostymulacji to skuteczne uzupełnienie terapii logopedycznej i leczenia ortodontycznego. 
Są całkowicie bezpieczne - impulsy TENS posiadają niskie natężenie i stymulują jedynie nerwy czuciowe na powierzchni skóry. Do elektrostymulacji wykorzystuje się wysokospecjalistyczny sprzęt medyczny. Wywiera ona ogromny wpływ na pracę mięśni i nerwów kluczowych w prawidłowej artykulacji. Pobudza włókna mięśniowe, dzięki czemu następuje wzmocnienie siły, przyrost masy oraz objętości mięśni.`
  }, 
  {
    name: "Terapia pedagogiczna indywidualna / terapia ręki",
    price: "130 zł",
    description: `Zajęcia trwają 45 minut.
Terapia pedagogiczna wspiera dzieci i młodzież z trudnościami w nauce. Skierowana jest miedzy innymi do uczniów z dysleksją, dysgrafią, dysortografią, dyskalkulią oraz trudnosciami z koncentarcją. Pomaga wyrównać braki edukacyjne i poprawić funkcjonowanie szkolne. Rozwija funkcje poznawcze: uwagę, pamięć, percepcję wzrokową i słuchową. Terapia wpływa na sprawność manualną i koordynację wzrokowo-ruchową. Wzmacnia wiarę we własne możliwości i motywację do nauki. 
Terapia pedagogiczna przeznaczona jest dla dzieci i młodzieży, które: 
  - mają trudności w nauce czytania, pisania, liczenia (np. dysleksja, dysgrafia, dysortografia, dyskalkulia), 
  - wykazują opóźnienia rozwoju funkcji poznawczych i percepcyjno-motorycznych, 
  - mają trudności z koncentracją i organizacją pracy, 
  - przejawiają zaburzenia emocjonalne lub problemy w relacjach społecznych.`
  },
  {
    name: "Trening Umiejętności Społecznych",
    price: "",
    description: `Zajęcia grupowe 70zł / 60 minut.
Zajęcia indywidualne 130zł / 45 minut.
Zajęcia indywidualne rodzeństwo 180zł / 60 minut.

To wsparcie dla dzieci nieśmiałych, z niską samooceną, impulsywnych, przejawiających zachowania agresywne, doświadczających problemów z nawiązywaniem relacji rówieśniczych.
Zajęcia mają na celu:
  - nabycie umiejętności rozpoznawania oraz nazywania swoich emocji i potrzeb,
  - poznanie metod radzenia sobie z trudnymi emocjami,
  - rozwijanie podstawowych umiejętności komunikacji,
  - zadbanie o własną przestrzeń osobistą,
  - pracę nad niepowodzeniami i wiarą we własne możliwości
  - zwrócenie uwagi na perspektywę innych osób,
  - doświadczenie nowych wzmacniających doświadczeń w sytuacjach społecznych,
  - wykształcenie umiejętności pracy w grupie.`
  },
]

interface Props {
  isVisible: boolean;
}

const Services: React.FC<Props> = (props) => {
  const [active, setActive] = useState<Service | null>(null);

  return (
    <section id="services" className="container h-auto overflow-hidden mt-10 2xl:rounded-3xl" style={{display: props.isVisible ? 'flex' : 'none'}}>
      <div className="w-full h-full flex flex-col items-center py-10">
        <div className="services w-100 h-30 flex flex-col items-center">
          <h1 className="text-4xl font-bold md:text-6xl">
              Usługi
          </h1>
          <motion.div className="line md:w-[40%] w-[60%] h-[3px] my-2" 
            initial={{scaleX: 0}} 
            whileInView={{scaleX: 1}} 
            transition={{ duration: 1 }}
            viewport={{ margin: "-20%", once: true}} />
        </div>

        {services.map((service) => (
            <motion.div className="md:w-[40%] w-full h-[40px] p-2 bg-[#edefef] rounded-2xl m-1 shadow-[0_5px_10px_rgba(0,0,0,0.5)] hover:cursor-pointer"
              style={{overflow: 'hidden'}}
              onClick={() => setActive(active === service ? null : service)}
              animate={{height: 'auto'}}
              transition={{ duration: 0.5, ease: "easeInOut" }}>
              <div className="flex flex-row gap-10 w-full justify-between font-bold">
                <div>
                  {service.name}
                </div>
                <div className="w-[75px]">
                  {service.price}
                </div>
              </div>
              <AnimatePresence>
                <motion.div style={{ overflow: "hidden", whiteSpace: "pre-wrap" }}
                  initial={{height: 0}}
                  animate={{height: active  === service ? 'auto' : 0}}
                  transition={{ duration: 0.5, ease: "easeInOut" }}>

                  {service.description}
                </motion.div>
              </AnimatePresence>
            </motion.div>
          ))}
      </div>
    </section>
  );
};

export default Services;